import React, { useCallback } from 'react';

import { Box } from '@adsk/alloy-react-box';
import Panel from '@adsk/alloy-react-panel';

import { useTranslation } from './i18n';
import StatusFilter from './StatusFilter';
import TemplateFilter from './TemplateFilter';
import FiltersHeader from '../../FiltersHeader';
import { applyFilterChange } from './helpers/filterHelpers';

const FormsFiltersPanel = ({
  filters,
  setFilters,
  open,
  onClose,
  floatingPanel,
  clearFilters,
  hasFilters,
}) => {
  const { t } = useTranslation();
  const onChangeFilter = useCallback(
    (key, value) => {
      setFilters(applyFilterChange(filters, key, value));
    },
    [filters, setFilters],
  );

  return (
    <Panel
      open={open}
      floating={floatingPanel}
      renderHeader={() => (
        <FiltersHeader
          onClose={onClose}
          title={t('FILTER_TITLE')}
          floatingPanel={floatingPanel}
          clearFilters={clearFilters}
          hasFilters={hasFilters}
        />
      )}
    >
      <Panel.Body>
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          <StatusFilter filters={filters} onChangeFilter={onChangeFilter} />
          <TemplateFilter filters={filters} onChangeFilter={onChangeFilter} />
        </Box>
      </Panel.Body>
    </Panel>
  );
};

export default FormsFiltersPanel;
